<template>
  <CDialog
    :title="$t('Download report')"
    :visible.sync="currentVisible"
    submittable
    :submit-label="$t('Download')"
    :submit-loading="loading"
    closeable
    @submit="onSubmit"
    @before-open="onBeforeOpen"
    @open="onOpen"
  >
    <span class="text-h6">{{ $t(`Please specify report columns`) }}</span>
    <div class="row dialog-wrapper q-mt-md">
      <Checkbox
        class="col-6"
        :key="`col-${colIndex}`"
        v-for="(col, colIndex) in columnOptions"
        v-model="col.value"
        :label="col.label"
        color="primary"
        @input="onSettingChange"
      />
    </div>
    <div class="row dialog-wrapper q-my-md">
      <div class="col-6">
        <Checkbox
          class="q-pr-sm"
          v-model="includeTags"
          :label="$t('Include Tags')"
          color="primary"
        />
        <HelpPopover placement="bottom">{{
          $t(
            'Tags will be included in the csv file by checking this option. This option will only works if Daily Report is checked.'
          )
        }}</HelpPopover>
      </div>
      <div class="col-6">
        <Checkbox
          class="q-pr-sm"
          v-model="dailyReport"
          :label="$t('Daily Report')"
          color="primary"
        /><HelpPopover placement="bottom">
          {{
            $t(
              'By checking this option Daily report will be generated in the csv file instead of the Monthly report.'
            )
          }}
        </HelpPopover>
      </div>
    </div>
  </CDialog>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import CDialog from '@/components/uikit/CDialog';
import Checkbox from '@design-system/components/Checkbox';
import HelpPopover from '@/components/uikit/HelpPopover';
import moment from 'moment';

export default Vue.extend({
  name: 'SelectReportColumnsDialog',
  components: { CDialog, Checkbox, HelpPopover },
  props: {
    value: {
      type: Boolean,
    },
    activeFilter: {
      type: String,
    },
    dateRange: {
      type: Object,
    },
  },
  data() {
    return {
      includeTags: true,
      dailyReport: false,
      columnOptions: [
        {
          label: 'Account',
          value: true,
          optionKey: 'resource',
        },
        {
          label: 'Product Code',
          value: false,
          optionKey: 'productCode',
        },
        {
          label: 'Service Code',
          value: true,
          optionKey: 'serviceCode',
        },
        {
          label: 'Region',
          value: false,
          optionKey: 'region',
        },
        {
          label: 'Zone',
          value: false,
          optionKey: 'zone',
        },
        {
          label: 'Usage Type',
          value: false,
          optionKey: 'usageType',
        },
        {
          label: 'Instance Type',
          value: false,
          optionKey: 'instanceType',
        },
        {
          label: 'Operation',
          value: false,
          optionKey: 'operation',
        },
        {
          label: 'Invoice',
          value: false,
          optionKey: 'invoiceId',
        },
        {
          label: 'Description',
          value: false,
          optionKey: 'description',
        },
        {
          label: 'Resource',
          value: false,
          optionKey: 'resourceId',
        },
      ],
      loading: false,
      restored: true,
    };
  },

  beforeMount() {
    const storedSettings = localStorage.getItem('reportFilterSettings');
    if (storedSettings) {
      const data = JSON.parse(storedSettings);
      data.map(({ value, optionKey }) => {
        const index = this.columnOptions.findIndex(item => item.optionKey === optionKey);
        if (index >= 0) {
          this.$set(this.columnOptions, index, {
            ...this.columnOptions[index],
            value,
          });
        }
      });
    }
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('reportFilters', {
      fetchReportUsingFilter: 'fetchReportUsingFilter',
    }),
    onBeforeOpen() {
      this.columns = [];
    },
    onOpen() {
      //
    },

    onSettingChange() {
      console.log('x');
      const data = JSON.parse(JSON.stringify(this.columnOptions));
      const store = data.map(({ value, optionKey }) => ({ value, optionKey }));
      localStorage.setItem('reportFilterSettings', JSON.stringify(store));
    },
    async onSubmit() {
      this.loading = true;
      const columnOptionsMapped = this.columnOptions.filter(op => op.value).map(op => op.optionKey);
      const groupByColumns =
        columnOptionsMapped.length > 0 ? columnOptionsMapped.join(',') : 'none';

      this.fetchReportUsingFilter({
        includeTags: this.includeTags,
        filterId: this.activeFilter,
        startTime: moment(this.dateRange.start).format('YYYYMMDD'),
        endTime: moment(this.dateRange.end).format('YYYYMMDD'),
        dailyReport: this.dailyReport,
        groupByColumns,
      })
        .then(() => {
          this.$message({
            message: this.$t('Report requested successfully'),
            type: 'success',
          });
          this.currentVisible = false;
        })
        .catch(e => {
          this.$message.error(
            e.response.data.message.replace(/./, c => c.toUpperCase()) || 'Error'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
</script>
<style>
.dialog-wrapper {
  max-width: 43vw !important;
}
</style>
